// extracted by mini-css-extract-plugin
module.exports = {"card":"TFymgGQuqhnPZQ7vT6tG","cardContent":"e8mb5WOopuUX19ZiuTsU","cardClicked":"gZi87pd2Yl_zePDb_zRN"};